module.exports = __webpack_public_path__ + "fonts/Roboto-Bold.1255186.woff2";